import axios from "axios";
const baseUrl = () => {
  if (process.env.REACT_APP_NODE_ENV === "development") {
    return process.env.REACT_APP_API_DEV_URL;
  } else if (process.env.REACT_APP_NODE_ENV === "production") {
    return process.env.REACT_APP_API_PROD_URL;
  }
};
// const url = "http://localhost:8000";
const url = "https://condo-app-server-2ef9df89c3da.herokuapp.com";
const rwaUrl = "https://rwa-f1623a22e3ed.herokuapp.com";

const API = axios.create({
  baseURL: baseUrl(),
  headers: {
    "Content-Type": "application/json",
    "Access-Control-Allow-Origin": "*",
  },
});

export const fetchCondo = async () => {
  const resp = await axios.get(`${url}/api/condo`);
  if (resp.data.success) {
    return resp.data.condoDetail;
  }
};

export const fetchCondoData = async () => {
  const resp = await axios.get(`${url}/api/condo/data`);
  if (resp.data.status) {
    return resp.data.condoData;
  }
};

export const fetchWalletData = async () => {
  const resp = await axios.get(`${url}/api/portfolio/data`);
  if (resp.data.status) {
    return resp.data.portfolio;
  }
};

export const fetchCondoOHLC = async () => {
  const resp = await axios.get(`${url}/api/condo/ohlc/chart`);
  if (resp.data.status) return resp.data.condoOHLC;
};

export const fetchCondoHistorical = async () => {
  const resp = await axios.get(`${url}/api/condo/historical/chart`);
  if (resp.data.status) return resp.data.condoHistorical;
};

// export const fetchPortfolioHistorical = async () => {
//   const resp = await axios.get(`${url}/api/portfolio/historical/chart`);
//   if (resp.data.status) return resp.data.portfolioHistorical;
// };
export const getAllTreasuryToken = (data) =>
  API.get(`${rwaUrl}/api/treasuryTokens/get/allTokens`, data);
export const fetchPortfolioHistorical = async () => {
  const resp = await API.get(`${rwaUrl}/api/portfolio/historical/chart`);
  if (resp.data.status) return resp.data.portfolioHistorical;
};
export const fetchCondoLiquidityPool = async () => {
  const resp = await axios.get(`${url}/api/condo/liqudityPool`);
  if (resp.data.status) return resp.data.liquidityPool;
};

export const fetchEth = async () => {
  const resp = await axios.get(`${url}/ethereum`);
  if (resp.data.success) {
    return resp.data.ethereumDetail;
  }
};

export const fetchAurusX = async () => {
  const resp = await axios.get(`${url}/aurusx`);
  if (resp.data.success) {
    return resp.data.aurusxDetail;
  }
};

export const fetchCoinDetail = async (coinId) => {
  const resp = await axios.get(`${url}/${coinId}`);
  if (resp.data.success) return resp.data.detail;
};

export const fetchBasePoolDetail = async (address) => {
  const resp = await axios.get(`${url}/api/pool/base/${address}`);
  if (resp.data.status) return resp.data.detail;
};

export const fetchIndexCoopDetail = async () => {
  const resp = await axios.get(
    "https://api.indexcoop.com/data/tokens/0xc884646e6c88d9b172a23051b38b0732cc3e35a6?metrics=nav"
  );
  if (resp.data.length > 0) {
    return resp.data[0].NetAssetValue;
  }
};
